import React, { useMemo } from 'react';
import GenericListPage from '../GenericListPage';
import InventoryForm from './InventoryForm'; // The form for adding/editing inventory items

const InventoryPage = () => {
  const inventoryColumns = useMemo(() => [
    {
      header: 'Product',
      key: 'productName', // Assuming your API returns productName or similar
      render: (item) => item.productId?.name || item.productName || 'N/A',
    },
    {
      header: 'SKU',
      key: 'productSku',
      render: (item) => item.productId?.sku || item.productSku || 'N/A',
    },
    {
      header: 'Quantity',
      key: 'quantity',
    },
    // Optional: If you implement multi-store
    // {
    //   header: 'Store',
    //   key: 'storeName',
    //   render: (item) => item.storeId?.name || item.storeName || 'N/A',
    // },
    {
      header: 'Remarks',
      key: 'remarks',
      render: (item) => item.remarks || 'N/A',
    },
    {
      header: 'Last Updated',
      key: 'updatedAt',
      render: (item) => item.updatedAt ? new Date(item.updatedAt).toLocaleString() : 'N/A',
    },
  ], []);

  const inventoryFilterConfig = useMemo(() => [
    {
      name: 'productId',
      type: 'select',
      label: 'Product',
      endpoint: 'products', // API to fetch products for dropdown
      keyField: '_id',
      valueField: 'name',
    },
    // Optional: If you implement multi-store
    // {
    //   name: 'storeId',
    //   type: 'select',
    //   label: 'Store',
    //   endpoint: 'stores', // API to fetch stores
    //   keyField: '_id',
    //   valueField: 'name',
    // },
    {
      name: 'hasLowStock', // Example: Add a filter for low stock items
      type: 'select',
      label: 'Stock Level',
      options: [
        { value: '', label: 'All' },
        { value: 'true', label: 'Low Stock' }, // Backend needs to support this query param
      ],
    }
  ], []);

  return (
    <GenericListPage
      title="Inventory Items" // Title for the page
      permission="manage_inventory" // Define appropriate permission
      entityEndpoint="inventory-items" // API endpoint for individual inventory items
      columns={inventoryColumns}
      FormComponent={InventoryForm}
      filterConfig={inventoryFilterConfig}
    />
  );
};

export default InventoryPage;